const unwrap = (mark: Element): void => {
    mark.replaceWith(...Array.from(mark.childNodes));
};

export const stripCommentMarks = (html: string): string => {
    const template = document.createElement('template');
    template.innerHTML = html;
    for (const mark of Array.from(template.content.querySelectorAll('mark[data-comment-id]'))) {
        unwrap(mark);
    }
    return template.innerHTML;
};

export const stripCommentMarkById = (html: string, commentId: string): string => {
    const template = document.createElement('template');
    template.innerHTML = html;
    for (const mark of Array.from(template.content.querySelectorAll('mark[data-comment-id]'))) {
        if (mark.getAttribute('data-comment-id') === commentId) {
            unwrap(mark);
        }
    }
    return template.innerHTML;
};
